import React, { FC } from 'react';
import { Col, FormGroup, FormLabel } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import CultureTextInput from '../../../../../../components/culture/CultureTextInput';
import { CultureTextModel } from '../../../../../../models/form/form';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../store';

interface Props {
  id: string;
  label: string;
  value: CultureTextModel[] | string;
  onChange: (e: CultureTextModel[] | string) => void;
  size?: number;
  readOnlyMode?: boolean;
  culture: string;
}

const CultureTextSetting: FC<Props> = ({
  id,
  label,
  value,
  onChange,
  culture,
  size = 12,
  readOnlyMode = false,
}: Props) => {
  const localizations = useSelector((state: RootState) => state.formAdmin.form?.localizations) as string[];

  return (
    <FormGroup className={'form-group'} as={Col} md={size}>
      <FormLabel>
        <FormattedMessage id={label} />
      </FormLabel>
      <CultureTextInput
        id={id}
        localizations={localizations}
        culture={culture}
        onChange={(e) => onChange(e)}
        value={value}
        readOnlyMode={readOnlyMode}
      />
    </FormGroup>
  );
};

export default CultureTextSetting;
